import $http from "../../../axios-instance";
import Swal from "sweetalert2";

/**
 * Obtener el programa de accidentes mayores y sus secciones
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getProgram({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("/slq-admin-high-accident/program-and-sections")
        .then(response => {
            commit("setProgram", response.data.data);
            commit("setSections", response.data.data.sections);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Obtener  seccion de accidentes mayores por el id
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function getSection({ commit, state, rootState }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`/slq-admin-high-accident/section-and-subsections/${id}`)
        .then(response => {
            commit("setSection", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar seccion de accidentes mayores.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function updateSection({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(
            `/slq-admin-high-accident/update-section/${state.section.id}`,
            state.section
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Actualizado!",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Obtener  sub seccion de accidentes mayores por el id.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function getSubSection({ commit, state, rootState }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`/slq-admin-high-accident/subsection-and-tables/${id}`)
        .then(response => {
            commit("setSubSection", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar sub seccion de accidentes mayores.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function updateSubSection({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(
            `/slq-admin-high-accident/update-subsection/${state.sub_section.id}`,
            state.sub_section
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Actualizado!",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Obtener  tabla de accidentes mayores por el id.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function getTable({ commit, state, rootState }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`/slq-admin-high-accident/table-and-columns/${id}`)
        .then(response => {
            commit("setTable", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar tabla de accidentes mayores.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function updateTable({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(
            `/slq-admin-high-accident/update-table/${state.table.id}`,
            state.table
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Actualizado!",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar columna de accidentes mayores.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function updateColumn({ commit, state, rootState }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(`/slq-admin-high-accident/update-column/${data.id}`, data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Actualizado!",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar programa de accidentes mayores.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function updateProgram({ commit, state, rootState }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(`/slq-admin-high-accident/update-program/${data.id}`, data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Actualizado!",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Cambiar estado de la seccion de accidentes mayores y pedir confirmacion usando sweetalert.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function changeStateSection({ commit, state, rootState }, data) {
    Swal.fire({
        title: "¿Estas seguro?",
        text: "¡Verifica tu acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar"
    }).then(result => {
        if (result.value) {
            data.active = data.active == 1 ? 0 : 1;
            commit("dashboard/load", true, { root: true });
            $http
                .put(`/slq-admin-high-accident/update-section/${data.id}`, data)
                .then(response => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        title: "Actualizado!",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                })
                .catch(error => {
                    commit("mensajeError", error.message);
                    commit("dashboard/load", false, { root: true });
                });
        }
    });
}

/**
 * Cambiar estado de la sub seccion de accidentes mayores y pedir confirmacion usando sweetalert.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function changeStateSubSection({ commit, state, rootState }, data) {
    Swal.fire({
        title: "¿Estas seguro?",
        text: "¡Verifica tu acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar"
    }).then(result => {
        if (result.value) {
            data.active = data.active == 1 ? 0 : 1;
            commit("dashboard/load", true, { root: true });
            $http
                .put(`/slq-admin-high-accident/update-subsection/${data.id}`, data)
                .then(response => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        title: "Actualizado!",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                })
                .catch(error => {
                    commit("mensajeError", error.message);
                    commit("dashboard/load", false, { root: true });
                });
        }
    });
}

/**
 * Cambiar estado de la tabla de accidentes mayores y pedir confirmacion usando sweetalert.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function changeStateTable({ commit, state, rootState }, data) {
    Swal.fire({
        title: "¿Estas seguro?",
        text: "¡Verifica tu acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar"
    }).then(result => {
        if (result.value) {
            data.active = data.active == 1 ? 0 : 1;
            commit("dashboard/load", true, { root: true });
            $http
                .put(`/slq-admin-high-accident/update-table/${data.id}`, data)
                .then(response => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        title: "Actualizado!",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                })
                .catch(error => {
                    commit("mensajeError", error.message);
                    commit("dashboard/load", false, { root: true });
                });
        }
    });
}

/**
 * Cambiar estado de la columna de accidentes mayores y pedir confirmacion usando sweetalert.
 *
 * return {Promise<void>}
 * author Luis Almendrales
 */
export async function changeStateColumn({ commit, state, rootState }, data) {
    Swal.fire({
        title: "¿Estas seguro?",
        text: "¡Verifica tu acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar"
    }).then(result => {
        if (result.value) {
            data.active = data.active == 1 ? 0 : 1;
            commit("dashboard/load", true, { root: true });
            $http
                .put(`/slq-admin-high-accident/update-column/${data.id}`, data)
                .then(response => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        title: "Actualizado!",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                })
                .catch(error => {
                    commit("mensajeError", error.message);
                    commit("dashboard/load", false, { root: true });
                });
        }
    });
}



